/* oxlint-disable eslint-plugin-react-hooks(exhaustive-deps) -- FIXME: pre-existing errors in hook dependencies */
import { useMemo } from 'react';

import { useAccountUsers } from '../utils/storeHooks';

import { AllSystemRoles } from '@payaca/permissions/default-role.config';
import {
  getUserRoles,
  userHasRequiredPermission,
} from '@payaca/permissions/permissions.utils';

export const useUsersWithPermissions = (userRequiredPermission?: string[]) => {
  const accountUsers = useAccountUsers();

  // oxlint-disable-next-line eslint-plugin-react-hooks(exhaustive-deps) -- FIXME: pre-existing error: React hook useMemo depends on getUserRolesForUserSystemRole which changes every render
  const getUserRolesForUserSystemRole = (userSystemRole: AllSystemRoles) => {
    return getUserRoles(userSystemRole, {});
  };

  // oxlint-disable-next-line eslint-plugin-react-hooks(exhaustive-deps) -- FIXME: pre-existing error: React hook useMemo depends on getUserRolesForUserSystemRole which changes every render
  const usersWithPermissions = useMemo(() => {
    const users = accountUsers.filter((x) => {
      const userRoles = getUserRolesForUserSystemRole(
        x.systemRole as AllSystemRoles
      );
      const assigneeUserHasPermission = userRequiredPermission?.length
        ? userHasRequiredPermission(userRoles, userRequiredPermission)
        : true;
      return (!x.deactivatedAt || x.inviteToken) && assigneeUserHasPermission;
    });
    return users;
  }, [accountUsers, getUserRolesForUserSystemRole, userRequiredPermission]);

  return usersWithPermissions;
};
